// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Types_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
var narrowRange = function (dictOrd) {
    return function (min) {
        return function (max) {
            return function (value) {
                if (Data_Ord.lessThan(dictOrd)(value)(min)) {
                    return min;
                };
                if (Data_Ord.greaterThan(dictOrd)(value)(max)) {
                    return max;
                };
                if (Data_Boolean.otherwise) {
                    return value;
                };
                throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.PromotionEvaluation (line 98, column 1 - line 98, column 51): " + [ min.constructor.name, max.constructor.name, value.constructor.name ]);
            };
        };
    };
};
var evaluateFreeby = function (v) {
    return function (item) {
        if (v instanceof Data_Maybe.Nothing) {
            return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setValue(Data_Maybe.Nothing.value)(item);
        };
        if (v instanceof Data_Maybe.Just) {
            return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setValue(new Data_Maybe.Just(Restaumatic_PromotionsEngine_Promotions_Promotion.freeProductValue(v.value0)))(item);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.PromotionEvaluation (line 69, column 1 - line 69, column 88): " + [ v.constructor.name, item.constructor.name ]);
    };
};
var evaluateActiveItem = function (dictEq) {
    return function (cartValue) {
        return function (evaluatedUnconditionally) {
            var inactive = Restaumatic_PromotionsEngine_Cart_PromotionalItem.setActive(false)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.setValue(Data_Maybe.Nothing.value)(evaluatedUnconditionally));
            var evaluated = (function () {
                var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionConditions(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotion(evaluatedUnconditionally));
                if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartPromotion && v.value0 instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartValue) {
                    var $21 = Data_Ord.greaterThanOrEq(Data_Money_Rounded.ordMoney)(cartValue)(v.value0.value0.minCartValue);
                    if ($21) {
                        return evaluatedUnconditionally;
                    };
                    return inactive;
                };
                return evaluatedUnconditionally;
            })();
            return evaluated;
        };
    };
};
var evaluateDisabledPromotionalItem = function (dictEq) {
    return function (inputCartData) {
        return function (cartValue) {
            return function (item) {
                var evaluatedUnconditionally = Restaumatic_PromotionsEngine_Cart_PromotionalItem.setActive(true)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.setValue(Data_Maybe.Nothing.value)(item));
                var evaluated = evaluateActiveItem(dictEq)(cartValue)(evaluatedUnconditionally);
                return {
                    accum: cartValue,
                    value: evaluated
                };
            };
        };
    };
};
var calcValueOfProductDiscount = function (dictEq) {
    return function (inputCartData) {
        return function (discountEvaluator) {
            return function (discount) {
                return function (productItemKey) {
                    var product = Restaumatic_PromotionsEngine_Cart_CartData.findProduct(dictEq)(inputCartData)(productItemKey);
                    var discountValue = Data_Functor.map(Data_Maybe.functorMaybe)((function () {
                        var $33 = discountEvaluator(discount);
                        return function ($34) {
                            return $33(Restaumatic_PromotionsEngine_Cart_ProductItem.productPrice($34));
                        };
                    })())(product);
                    return discountValue;
                };
            };
        };
    };
};
var calcValueOfCartDiscount = function (inputCartData) {
    return function (discountEvaluator) {
        return function (discount) {
            return new Data_Maybe.Just(discountEvaluator(discount)(Restaumatic_PromotionsEngine_Cart_CartData.calcSubtotalInputCartData(inputCartData)));
        };
    };
};
var evaluateDiscount = function (dictEq) {
    return function (discountEvaluator) {
        return function (inputCartData) {
            return function (item) {
                return function (discount) {
                    var valueDiscount = (function () {
                        var v = Restaumatic_PromotionsEngine_Cart_PromotionalItem.assignment(item);
                        if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToProduct) {
                            return calcValueOfProductDiscount(dictEq)(inputCartData)(discountEvaluator)(discount)(v.value0);
                        };
                        if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToCart) {
                            return calcValueOfCartDiscount(inputCartData)(discountEvaluator)(discount);
                        };
                        return Data_Maybe.Nothing.value;
                    })();
                    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setValue(valueDiscount)(item);
                };
            };
        };
    };
};
var calcPriceDiscountSmallerThanPrice = function (priceDiscount) {
    return function (price) {
        var realPriceDiscount = (function () {
            var $27 = Data_Ord.lessThanOrEq(Data_Money_Rounded.ordMoney)(price)(priceDiscount);
            if ($27) {
                return Data_Numeric.negate(Data_Money_Rounded.additiveMoney)(price);
            };
            return Data_Numeric.negate(Data_Money_Rounded.additiveMoney)(priceDiscount);
        })();
        return realPriceDiscount;
    };
};
var evaluatePriceDiscount = function (dictEq) {
    return evaluateDiscount(dictEq)(calcPriceDiscountSmallerThanPrice);
};
var calcPriceDiscountNormalized = function (priceDiscount) {
    return function (price) {
        var normPriceDiscount = narrowRange(Data_Money_Rounded.ordMoney)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(price)(priceDiscount);
        return Data_Numeric.negate(Data_Money_Rounded.additiveMoney)(normPriceDiscount);
    };
};
var calcPercentageDiscount = function (percentageDiscount) {
    return function (price) {
        var normPercentageDiscount = narrowRange(Data_Ord.ordInt)(Data_Numeric.negate(Data_Numeric.additiveInt)(100))(100)(percentageDiscount);
        return Data_Money_Rounded.scaleByPercentAndRound(Data_Numeric.negate(Data_Numeric.additiveNumber)(Data_Int.toNumber(normPercentageDiscount)))(price);
    };
};
var evaluatePercentageDiscount = function (dictEq) {
    return evaluateDiscount(dictEq)(calcPercentageDiscount);
};
var evaluateEnabledPromotionalItem = function (dictEq) {
    return function (inputCartData) {
        return function (cartValue) {
            return function (item) {
                var evaluatedUnconditionally = Restaumatic_PromotionsEngine_Cart_PromotionalItem.setActive(true)((function () {
                    var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionPrize(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotion(item));
                    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Freeby) {
                        return evaluateFreeby(Restaumatic_PromotionsEngine_Cart_PromotionalItem.selectedFreeby(item))(item);
                    };
                    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.PercentageDiscount) {
                        return evaluatePercentageDiscount(dictEq)(inputCartData)(item)(v.value0);
                    };
                    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.PriceDiscount) {
                        return evaluatePriceDiscount(dictEq)(inputCartData)(item)(v.value0);
                    };
                    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CouponValue) {
                        return item;
                    };
                    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.TextInformation) {
                        return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setValue(Data_Maybe.Nothing.value)(item);
                    };
                    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.PromotionEvaluation (line 52, column 47 - line 57, column 45): " + [ v.constructor.name ]);
                })());
                var evaluated = evaluateActiveItem(dictEq)(cartValue)(evaluatedUnconditionally);
                var maybeValueDiff = Data_Maybe.fromMaybe(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.value(evaluated));
                return {
                    accum: Data_Numeric.add(Data_Money_Rounded.additiveMoney)(cartValue)(maybeValueDiff),
                    value: evaluated
                };
            };
        };
    };
};
var evaluatePromotionalItem = function (dictEq) {
    return function (inputCartData) {
        return function (cartValue) {
            return function (item) {
                var $32 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabled(item);
                if ($32) {
                    return evaluateEnabledPromotionalItem(dictEq)(inputCartData)(cartValue)(item);
                };
                return evaluateDisabledPromotionalItem(dictEq)(inputCartData)(cartValue)(item);
            };
        };
    };
};
var evaluateEnabledPromotionalItems = function (dictEq) {
    return function (inputCartData) {
        return function (items) {
            var sortedItems = Data_Array.sort(Restaumatic_PromotionsEngine_Cart_PromotionalItem.ordPromotionalItem(dictEq))(items);
            var initCartValue = Restaumatic_PromotionsEngine_Cart_CartData.calcSubtotalInputCartData(inputCartData);
            var accumResult = Data_Traversable.mapAccumL(Data_Traversable.traversableArray)(evaluatePromotionalItem(dictEq)(inputCartData))(initCartValue)(sortedItems);
            return Data_Array.sortWith(Data_Ord.ordInt)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionalItemId)(accumResult.value);
        };
    };
};
export {
    calcPercentageDiscount,
    calcPriceDiscountSmallerThanPrice,
    calcPriceDiscountNormalized,
    evaluateEnabledPromotionalItems,
    evaluatePromotionalItem,
    evaluateDisabledPromotionalItem,
    evaluateEnabledPromotionalItem,
    evaluateActiveItem,
    evaluateFreeby,
    evaluatePriceDiscount,
    evaluatePercentageDiscount,
    evaluateDiscount,
    calcValueOfProductDiscount,
    calcValueOfCartDiscount,
    narrowRange
};
//# sourceMappingURL=index.js.map
